import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from 'react';
import { AiOutlineLogout, AiOutlineSearch } from "react-icons/ai";
import { MdOutlineNotificationsNone } from "react-icons/md";
import { useNavigate } from "react-router-dom";


const SearchPanel = () => {


    const { instance } = useMsal();

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: msalConfigAuthOptions.postLogoutRedirectUri,
        });
    };


    const navigate = useNavigate();
    const [dropDown, setDropDown] = useState(true);
    const [darkTheme, setDarkTheme] = useState(false);

    const DropdownToggle = () => {
        setDropDown(!dropDown)
    }
    const getUserDetails = (e) => {
        if (sessionStorage.getItem('User') !== null) {
            var a = JSON.parse(sessionStorage.getItem('User'));
            if (a) {
                 return a[e];
            }
        }
    }

    useEffect(() => {
        // Accessing scss variable "--background-color"
        // and "--text-color" using plain JavaScript
        // and changing the same according to the state of "darkTheme"
        //const root = document.documentElement;
        //root?.style.setProperty(
        //    "--theme-primary-color",
        //    darkTheme ? "#346a3d" : "#422afb"
        //);

        const queryString = window.location.href;
        console.log(queryString);
        getUserDetails();
    }, [darkTheme]);

    return (<>

        <div className="searchPanel">
            <div className="searchInputWrapper d-none">
                <AiOutlineSearch size="18" />
                <input type="text" className="" placeholder="Search" />
            </div>
            {/*<CgEditContrast size="20" className="colorLight cursorPointer" onClick={() => setDarkTheme(!darkTheme)} />*/}
            <MdOutlineNotificationsNone size="20" className="colorLight cursorPointer d-none" />
            <div className="userName" onClick={DropdownToggle}>
                {getUserDetails('firstName') && getUserDetails('firstName').slice(0, 1)}{getUserDetails('lastName') && getUserDetails('lastName').slice(0, 1)}
                <div className={`panelDropdownProfile ${dropDown ? 'd-none' : ''}`}>
                    <div className="profileDropdownItem border-bottom-light profileDropdownName">
                        👋 {getUserDetails('firstName')} {getUserDetails('lastName')}
                    </div>
                    <div className="profileDropdownItem LogoutDropdown border-top-light" onClick={handleLogout}>
                        <AiOutlineLogout size="18" /> Logout
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default SearchPanel;